import React, { useState } from "react";
import AddCompanyAccountModal from "@/components/company/addCompanyAccountModal";
import { getCompanyUrlAliasFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
import Avatar from "@/components/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import history from "@/interfaces/history";
import { t } from "@/i18n";
import DropdownMenu from "@/components/dropdownMenu";
import { useUserCompanies } from "@/hooks/companies/useUserCompanies";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
import { ChevronsUpDown, HousePlus } from "lucide-react";
const CompanyAccountSwitcher = () => {
  const { data: userCompaniesQuery, isLoadingCompanies } =
    useUserCompanies("me");
  const userCompanies = userCompaniesQuery?.data?.filter((c) => !c.isCanceled);

  const [showModal, setShowModal] = useState(false);

  const currentCompanyUrlAlias = getCompanyUrlAliasFromUrl();
  const currentCompanyId = useCompanyIdFromUrl();

  const currentCompany = userCompanies?.find(
    (company) => company.id === currentCompanyId,
  );

  const loadingElement = (
    <div className="flex items-center gap-2">
      <Skeleton className="h-[20px] w-[20px]" />
      <Skeleton className="h-[20px] w-[100px]" />
      <ChevronsUpDown size={16} className="text-slate-300" />
    </div>
  );

  const isLoading =
    isLoadingCompanies || (!!currentCompanyUrlAlias && !currentCompany);

  if (isLoading) {
    return loadingElement;
  }

  const handleSelectCompany = (companyId) => {
    const selectedCompany = userCompanies?.find(
      (company) => company.id === companyId,
    );

    if (selectedCompany) {
      history.push(`/${selectedCompany.urlAlias}`);
    }
  };

  let options = [];

  options = [
    ...options,
    ...(userCompanies?.map((company) => ({
      label: (
        <div className="gap-sm flex items-center">
          <Avatar id={company.id} name={company.name} type="company" />
          <div>
            <div>{company.name}</div>
            <div className="text-slate-500">{company.orgNumber}</div>
          </div>
        </div>
      ),
      value: company.id,
    })) ?? []),
  ];

  options = [
    ...options,
    {
      label: t("dashboard.company_accounts.body.create_account"),
      icon: <HousePlus />,
      value: "create",
      onClick: () => setShowModal(true),
    },
  ];

  return (
    <>
      <DropdownMenu
        onSelect={handleSelectCompany}
        trigger={
          <div className="gap-sm flex items-center" role="button">
            <Avatar
              id={currentCompanyId}
              name={currentCompany?.name}
              type="company"
              size="sm"
            />
            {currentCompany?.name ??
              t("personal-documents.choose-target-company")}
            <ChevronsUpDown size={16} />
          </div>
        }
        options={options}
      />
      <AddCompanyAccountModal
        open={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default CompanyAccountSwitcher;
export { CompanyAccountSwitcher };
